import type { EngineInput, EngineResult } from './estimate.types';
import { calculateEstimate as calculateStrategyEstimate } from './engines/estimateEngine';
import { calculateEstimate as calculateSimpleEstimate } from './simpleEstimateEngine';

export function calculateQuickEstimate(input: EngineInput): EngineResult {
  const isBathroom = input.tradeEngine === 'bathroom' || input.trade === 'lazienka';

  return isBathroom
    ? calculateStrategyEstimate(input)
    : calculateSimpleEstimate(input);
}
